import React from "react";
import {
  MainHeader,
  HeaderContainer,
  ButtonSection,
  CardSection,
  ResourceCard,
  ButtonContainer,
} from "./styles";
import { Resource } from "../../components/Resource";
import { getFavouritesList } from "../../services/favourites/getFavourites";
import Spinner from "../../components/Spinner/Spinner";
import { ResourceSkeleton } from "../../components/ResourceSkeleton";
import ResourceButton from "../../components/ResourceButton/ResourceButton";
import { getCategoriesList } from "../../services/categories/getCategories";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/constants";
import { NullDescription, NullMessage, NullPage } from "../Reservations/styles";

const Favourites = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");
  const userType = localStorage.getItem("user_type");

  const navigate = useNavigate();

  // ------------------- REMOVE THIS -------------------
  const images = [
    "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
    "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg",
    "https://images.unsplash.com/photo-1554260570-e9689a3418b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2364&q=80",
    "https://images.unsplash.com/photo-1614028674026-a65e31bfd27c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
    "https://images.unsplash.com/photo-1564038057903-1d48b852b412?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
  ];

  // ------------------- STATES -------------------
  const [loadingFavourites, setLoadingFavourites] = React.useState(false); // Loading state
  const [favouritesList, setFavouritesList] = React.useState<any>([]); // Favourites list state
  const [mainFavouritesList, setMainFavouritesList] = React.useState<any>([]); // Favourites list state
  const [categoriesList, setCategoriesList] = React.useState<any>([]); // Categories list state
  const [loadingCategories, setLoadingCategories] = React.useState(false); // Loading state
  const [filteredList, setFilteredList] = React.useState<any>([]);
  const [selectedCategories, setSelectedCategories] = React.useState<string[]>(
    []
  );

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setLoadingFavourites(true);
    getFavourites();
    getCategories();
  }, []);

  React.useEffect(() => {
  }, [favouritesList]);

  React.useEffect(() => {
    // Filtra los recursos en favoritesList según las categorías seleccionadas
    let filteredResources = favouritesList;

    if (selectedCategories.length > 0) {
      filteredResources = favouritesList.filter((resource: any) =>
        selectedCategories.includes(resource.resource_category)
      );
    }
    
    setFilteredList(filteredResources);
  }, [favouritesList, selectedCategories]);

  // ------------------- GET RESOURCES FROM API -------------------
  const getFavourites = async () => {
    await getFavouritesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setFavouritesList(res.data.favourites_list);
          setMainFavouritesList(res.data.favourites_list);
          // console.log(res.data.favourites_list);
        }
      })
      .catch((err) => {});

    setLoadingFavourites(false);
  };

  const getCategories = async () => {
    await getCategoriesList(jwt!)
      .then((res) => {
        if (res && res.data) {
          setCategoriesList(res.data);
        }
      })
      .catch((err) => {});

    setLoadingCategories(false);
  };

  const handleCategorySelect = (categoryName: string) => {
    // Clonamos el arreglo de categorías seleccionadas actual
    const updatedCategories = [...selectedCategories];

    // Verificamos si la categoría ya está seleccionada
    const index = updatedCategories.indexOf(categoryName);

    if (index !== -1) {
      // Si la categoría ya estaba seleccionada, la eliminamos
      updatedCategories.splice(index, 1);
    } else {
      // Si la categoría no estaba seleccionada, la agregamos
      updatedCategories.push(categoryName);
    }

    // Actualizamos el estado con el nuevo arreglo de categorías seleccionadas
    setSelectedCategories(updatedCategories);
  };

  const numberOfSkeletons = 15;

  return (
    <>
      {!loadingFavourites ? (
        <div>
          <HeaderContainer>
            <MainHeader>Mis Favoritos</MainHeader>
          </HeaderContainer>

          <ButtonSection>
            {categoriesList.length > 0 ? (
              categoriesList.map((category: any) => (
                <ButtonContainer key={category.name}>
                  <ResourceButton
                    label={category.name}
                    icon={category.image}
                    onClick={() => handleCategorySelect(category.name)}
                    active={selectedCategories.includes(category.name)} // Activa el botón si la categoría está seleccionada
                  />
                </ButtonContainer>
              ))
            ) : (
              <p>No tienes categorías</p>
            )}
          </ButtonSection>

          <CardSection>
            {filteredList.length > 0 ? (
              filteredList.map((resource: any) => (
                <ResourceCard>
                  <Resource
                    key={resource.id}
                    name={resource.resource_name}
                    description={resource.description}
                    location={resource.location}
                    images={
                      resource.images.length > 0
                        ? resource.images.map((img: any) => img.url)
                        : images
                    }
                    resourceId={resource.id}
                    onClick={() => navigate(`/details/${resource.id}`)}
                  />
                </ResourceCard>
              ))
            ) : (
              <NullPage>
                <NullMessage>No encontramos Favoritos</NullMessage>
                <NullDescription>
                  Agrega favoritos o aplica algún otro filtro
                </NullDescription>
              </NullPage>
            )}
          </CardSection>
        </div>
      ) : (
        <>
          <HeaderContainer>
            <MainHeader>Mis Favoritos</MainHeader>
          </HeaderContainer>

          <ButtonSection>Botones</ButtonSection>
          <CardSection>
            {Array.from({ length: numberOfSkeletons }, (_, index) => (
              <ResourceCard>
                <ResourceSkeleton />
              </ResourceCard>
            ))}
          </CardSection>
        </>
      )}
    </>
  );
};

export default Favourites;
